import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { Typography, Button } from "@mui/material";
import { useIntl } from "react-intl";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import IconButton from "@mui/material/IconButton";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import QCDataHeader from "../../components/ui/QC/QCDataHeader";
import { useLoading } from "../../components/LoadingContext";
import axios from "../../api/axiosClient";
import { handleError, errorToast, dataURLtoFile } from "../../services/serviceBase";
import { toast } from "react-hot-toast";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useSelector } from "react-redux";
import { Buffer } from "buffer";
import { useNavigate } from "react-router-dom";
import ShootPhoto from "../../components/ui/ShootPhoto";

export default function QCDefectAttachments(props) {
  const intl = useIntl();
  const params = useParams();
  const { idReturnFileHead, idArticle, idDefectForQC, hash } = params;
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  const [returnFileByArticle, setReturnFileByArticle] = useState("");
  const [maxQuantity, setMaxQuantity] = useState(0);
  const [existingLocation, setExistingLocation] = useState("");
  const [existingSublocation, setExistingSublocation] = useState("");
  const [existingProblem, setExistingProblem] = useState("");
  const [existingResponsibility, setExistingResponsibility] = useState("");
  const [existingAttach, setExistingAttach] = useState([]);
  const [existingNote, setExistingNote] = useState("");
  const [renderAttach, setRenderAttach] = useState([]);
  const [activeAttachment, setActiveAttachment] = useState("");
  const [renderActiveAttachment, setRenderActiveAttachment] = useState("");
  const [currentDefectDetail, setCurrentDefectDetail] = useState(null);
  const [showTakePhoto, setShowTakePhoto] = useState(false);

  const currentIdQualityCheck = useSelector((state) => state.qc.idQualityCheck);

  useEffect(() => {
    GetReturnFileByArticle();
    setActiveAttachment(hash);
    if (idDefectForQC != null) {
      getExistingDefect();
      getDefectDetail(idDefectForQC);
    }
  }, []);

  const GetReturnFileByArticle = () => {
    setLoading(true);
    var url = "returnfiles/" + idReturnFileHead + "/" + idArticle;
    axios
      .get(url)
      .then((response) => {
        setLoading(false);
        if (
          response != null &&
          response != undefined &&
          response.data !== null &&
          response.data !== undefined
        ) {
          setReturnFileByArticle(response.data);
          setMaxQuantity(response.data.quantity);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getExistingDefect = () => {
    setLoading(true);
    var url = `/qualitycheck/${currentIdQualityCheck}/defects/${idDefectForQC}`;
    axios
      .get(url)
      .then((response) => {
        setLoading(false);
        var location = "";
        var subloc = "";
        var problem = "";
        var resp = "";
        response.data.attributesList.map((defect) => {
          if (defect.label == "Location") {
            location = defect.attributeName;
          } else if (defect.label == "Subloc") {
            subloc = defect.attributeName;
          } else if (defect.label == "Problem") {
            problem = defect.attributeName;
          } else if (defect.label == "Responsability") {
            resp = defect.attributeName;
          }
        });
        setExistingNote(response.data.note);
        setExistingLocation(location);
        setExistingSublocation(subloc);
        setExistingProblem(problem);
        setExistingResponsibility(resp);

        var existingImages = [];
        response.data.hashList.map((x) => {
          existingImages.push(x);
        });
        setExistingAttach(existingImages);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  function getExistingDefectAttachments(idDefect, hash) {
    setLoading(true);
    axios
      .get(
        `/qualitycheck/${currentIdQualityCheck}/defects/${idDefect}/attachments/${hash}`,
        {
          responseType: "arraybuffer",
        }
      )
      .then((response) => {
        setLoading(false);
        var base64 = Buffer.from(response.data).toString("base64");
        setRenderActiveAttachment(base64);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  }

  const getExistingDefectThumbnail = async (idDefect, hash) =>  {
    setLoading(true);
    return axios
      .get(
        `/qualitycheck/${currentIdQualityCheck}/defects/${idDefect}/thumbnails/${hash}`,
        {
          responseType: "arraybuffer",
        }
      )
      .then((response) => {
        setLoading(false);
        var base64 = Buffer.from(response.data).toString("base64");
        return {attachment: base64, hash: hash};
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  }

  const getDefectDetail = (idDefect) => {
    setLoading(true);
    axios
      .get("qualitycheck/" + currentIdQualityCheck + "/defects/" + idDefect)
      .then((response) => {
        setLoading(false);
        if (
          response != null &&
          response != undefined &&
          response.data !== null &&
          response.data !== undefined
        ) {
          var defectDetail = {
            idDefect: idDefect,
            Details: response.data,
          };
          setCurrentDefectDetail(defectDetail);

          const promises = defectDetail.Details.hashList.map(x => getExistingDefectThumbnail(currentDefectDetail?.idDefect, x));
          Promise.all(promises).then(images => {
            setLoading(false);
            setRenderAttach(images);
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const onSelectFile = (e) => {
    var reader = new FileReader();
    reader.onload = function (event) {
      handleUploadPhoto(e.target.files[0], event.target.result.replace("data:image/png;base64,", ""));

    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const handleImageClick = (e, hash) => {
    setActiveAttachment(hash);
  };

  const handleGoBack = (e) => {
    navigate(
      `${process.env.PUBLIC_URL}/QCItem/${idReturnFileHead}/${idArticle}`
    );
  };

  useEffect(() => {
    if (activeAttachment.length > 0) {
      getExistingDefectAttachments(idDefectForQC, activeAttachment);
    }
  }, [activeAttachment]);

  const handleDeleteAttachmentClick = (hash) => {
    setLoading(true);
    axios
      .delete(`/qualitycheck/${currentIdQualityCheck}/attachments/${hash}`)
      .then((response) => {
        setLoading(false);
        toast.success("Deleted!");

        let newRenderAttach = [];
        renderAttach.map((x) => newRenderAttach.push(x));
        const index = renderAttach.findIndex((x) => x.hash == hash);
        if (index > -1) {
          newRenderAttach.splice(index, 1);
        }
        setRenderAttach(newRenderAttach);
        setActiveAttachment("");
        setRenderActiveAttachment("");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleUploadPhoto = (file, base64) => {
    setLoading(true);
    const data = new FormData();
    data.append("file", file);
    var url = `/qualitycheck/${currentIdQualityCheck}/defects/${idDefectForQC}/attachments`;
    axios
      .post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        toast.success("Saved!");
        getDefectDetail(idDefectForQC);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  
  const handlePhotoTakenAction = (dataUri) => {
    var file = dataURLtoFile(dataUri, "aa.png");
    handleUploadPhoto(file, dataUri.replace("data:image/png;base64,", ""));
    setShowTakePhoto(false);
  }

  const handleExitShootPhoto = () => {
    setShowTakePhoto(false);
  }

  const handleBefore = () => {
    var currentHash = activeAttachment;
    var currentIndex = currentDefectDetail.Details.hashList.findIndex(x => x == currentHash);

    if(currentIndex > -1){
      currentIndex = currentIndex - 1;
    }

    if(currentIndex >= 0){
      currentHash = currentDefectDetail.Details.hashList[currentIndex];
    }
    else{
      currentHash = currentDefectDetail.Details.hashList[currentDefectDetail.Details.hashList.length-1];
    }

    setActiveAttachment(currentHash);
    getExistingDefectAttachments(idDefectForQC, currentHash);
  }

  const handleNext = () => {
    var currentHash = activeAttachment;
    var currentIndex = currentDefectDetail.Details.hashList.findIndex(x => x == currentHash);

    if(currentIndex > -1){
      currentIndex = currentIndex + 1;
    }

    if(currentIndex <= currentDefectDetail.Details.hashList.length-1){
      currentHash = currentDefectDetail.Details.hashList[currentIndex];
    }
    else if(currentDefectDetail.Details.hashList.length > 0){
      currentHash = currentDefectDetail.Details.hashList[0];
    }    

    setActiveAttachment(currentHash);
    getExistingDefectAttachments(idDefectForQC, currentHash);
  }

  return (
    <>
      {
        showTakePhoto ? 
        <ShootPhoto photoTakenAction={handlePhotoTakenAction} exitShootPhoto={handleExitShootPhoto} />
        :
        <Grid container>
          <Grid item xl={12}>
            <div id="QCheader">
              <QCDataHeader
                article={returnFileByArticle?.articleInfo}
                head={returnFileByArticle?.returnFileHeadInfo}
                quantity={returnFileByArticle?.quantity}
              />
            </div>
          </Grid>
          <Grid container mt={2}>
            <Grid item xl={6}>
              <div id="attachmentContainer" style={{ border: "4px solid black" }}>
                {renderActiveAttachment.length > 0 ? (
                  <img
                    src={`data:;base64,${renderActiveAttachment}`}
                    id="attachmentDetail"
                  />
                ) : (
                  <img
                    src={require("../../img/no_image.png")}
                    id="attachmentDetail"
                  />
                )}
              </div>
            </Grid>
            <Grid item xl={6} xs={12} style={{ paddingLeft: 10 }}>
              <Grid
                container
                sx={{ color: "grey", p: 0.5, borderBottom: "4px solid red" }}
              >
                <Grid item xl={9}>
                  <Typography variant="h5" sx={{ color: "grey", p: 0.5, mt: 1 }}>
                    {intl.formatMessage({ id: "QC.Defect" })} # {idDefectForQC}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton className="apeLigthBlueColor" onClick={handleBefore}>
                    <NavigateBeforeIcon fontSize="large"/>
                  </IconButton>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}>
                  <IconButton className="apeLigthBlueColor" onClick={handleNext}>
                    <NavigateNextIcon fontSize="large"/>
                  </IconButton>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xl={12}>
                  <ul
                    style={{ listStyleType: "none", padding: 0, marginLeft: 5 }}
                  >
                    <li key={"location"}>
                      {intl.formatMessage({ id: "QC.Location" })}:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {existingLocation}
                      </span>
                    </li>
                    <li key={"sublocation"}>
                      {intl.formatMessage({ id: "QC.Subloc" })}:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {existingSublocation}
                      </span>
                    </li>
                    <li key={"problem"}>
                      {intl.formatMessage({ id: "QC.Problem" })}:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {existingProblem}
                      </span>
                    </li>
                    <li key={"responsibility"}>
                      {intl.formatMessage({ id: "QC.Responsibility" })}:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {existingResponsibility}
                      </span>
                    </li>
                  </ul>
                </Grid>
              </Grid>
              <Grid container>
                {
                  renderAttach?.map((x, i) => {
                      return (
                        <Grid item ml={1} xs={2}>
                          <img
                            src={`data:;base64,${x.attachment}`}
                            width={100}
                            height={100}
                            key={x.hash}
                            onClick={(event) => handleImageClick(event, x.hash)}
                          />
                        </Grid>
                      );
                    })
                  }
                <Grid item ml={1} xs={2}>
                  <IconButton
                    sx={{ pl: 0, pt: 0 }}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowTakePhoto(true);
                    }}
                  >
                    <CameraAltOutlinedIcon
                      sx={{
                        fontSize: 100,
                        color: "white",
                        backgroundColor: "#007cd6",
                      }}
                    />
                  </IconButton>
                </Grid>
                <Grid item ml={1} xs={2}>
                  <Button
                    component="label"
                    tabIndex={-1}
                    sx={{ pt: 0 }}
                    startIcon={
                      <AddPhotoAlternateOutlinedIcon
                        style={{
                          fontSize: 100,
                          color: "white",
                          backgroundColor: "#007cd6",
                        }}
                      />
                    }
                  >
                    <input
                      type="file"
                      multiple
                      onInput={onSelectFile}
                      id="getimage"
                      accept="image/png, image/jpeg"
                    ></input>
                  </Button>
                </Grid>
              </Grid>
              <Grid container pt={10}>
                <Grid item xs={12}>
                  <IconButton
                    sx={{ pl: 0 }}
                    onClick={() => {
                      handleDeleteAttachmentClick(activeAttachment);
                    }}
                  >
                    <DeleteForeverIcon
                      sx={{
                        fontSize: 37,
                        color: "white",
                        backgroundColor: "#007cd6",
                        borderRadius: 1,
                        paddingLeft: 1,
                        paddingRight: 1,
                      }}
                    />
                  </IconButton>
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleGoBack();
                    }}
                  >
                    {intl.formatMessage({ id: "General.Cancel" })}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
      
    </>
  );
}
